<template>
  <div class="template">
    <ApplicationWebDesktop class="template__Desktop" />
    <ApplicationWebMobile class="template__Mobile" />
  </div>
</template>

<script>
import ApplicationWebDesktop from '@/components/services/Applidation-Web/ApplicationWebDesktop.vue'
import ApplicationWebMobile from '@/components/services/Applidation-Web/ApplicationWebMobile.vue'
export default {
  name: 'ApplicationWebView',
  components: {
    ApplicationWebDesktop,
    ApplicationWebMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>